import { render, staticRenderFns } from "./ticketItem.vue?vue&type=template&id=51f71bd5&scoped=true"
import script from "./ticketItem.vue?vue&type=script&lang=js"
export * from "./ticketItem.vue?vue&type=script&lang=js"
import style0 from "./ticketItem.vue?vue&type=style&index=0&id=51f71bd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f71bd5",
  null
  
)

export default component.exports